import { Helmet } from "react-helmet";
import { useState } from 'react';
import FrontImage from "../Assets/Images/Front_Image.png";
import "./Home.css";
import Typewriter from "typewriter-effect";
import GoogleReviewSection from "./GoogleReviewSection.js";
import ServiceCard from "./ServiceCard.js";
import Section4 from "./Section4.js";
import LogoSection from "./LogoSection.js";
import WhatWeDoSection from "./WhatWeDoSection.js";
import ContactForm from "../ContactForm/ContactFormModal.js";


const Home = () => {
  const [showContactForm, setShowContactForm] = useState(false);

  const handleCloseContactForm = () => {
    setShowContactForm(false);
  };

  return (
    <main>
      <Helmet> <title>US Tax & Bookkeeping Services | Outsourced from India | BooksComply</title>
        <meta name="description"
          content="BooksComply provides expert US tax filing, bookkeeping, CFO advisory, and USA business incorporation services from India. 
       Trusted by clients across the USA." />
        <meta name="keywords"
          content="US Tax Filing from India, USA Bookkeeping Services, Outsourced Accounting, Indian CPA for US Tax, 1099 Filing, 
        CFO Advisory USA, Incorporate Business in USA, Virtual Bookkeeping USA, Remote CPA Services, Affordable Bookkeeping USA" />
        <meta name="robots" content="index, follow" /> <meta property="og:title"
          content="US Tax & Bookkeeping Experts | BooksComply" /> <meta property="og:description"
            content="Expert US tax filing, virtual bookkeeping, CFO advisory, and incorporation services for US clients from India." />
        <meta property="og:image" content="https://bookscomply.com/assets/Images/Front_Image.png" /> <meta property="og:url"
          content="https://bookscomply.com" /> <meta name="twitter:card" content="summary_large_image" />
      </Helmet>


      <section id="homeSection" className="bg-light pt-5 pb-3">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Column: Taglines */}
            <div className="col-md-6">
              <h1 className="display-3 fw-bolder mb-3">
                <span className="text-black-force">Grow Your U.S. Business with</span>
                <br />
                <span className="typewriter-text text-accent fw-normal font-change font-change1">
                  <Typewriter
                    options={{
                      strings: ["Bookkeeping", "CFO Advisory", "USA Business Incoporation", "Tax Return"],
                      autoStart: true,
                      loop: true,
                      deleteSpeed: 0.1,
                    }}
                  />
                </span>
              </h1>
              <p className="lead mt-4 text-black-force" style={{ color: '#000000' }}>
                BooksComply helps startups and entrepreneurs simplify company formation in the USA, manage tax filing, and streamline bookkeeping services — all handled by certified professionals.
              </p>
              <div className="d-flex flex-wrap gap-3 mt-4">
                <button
                  className="btn btn-primary-1 rounded-pill px-4 py-2"
                  onClick={() => setShowContactForm(true)}
                  style={{
                    backgroundColor: '#0d6efd',
                    border: 'none',
                    boxShadow: '0 4px 6px rgba(13, 110, 253, 0.2)',
                    transition: 'all 0.3s ease',
                    minWidth: '200px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 12px rgba(13, 110, 253, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 6px rgba(13, 110, 253, 0.2)';
                  }}
                >
                  Book a Free Consultation
                </button>
                <button
                  className="btn btn-outline-primary rounded-pill px-4 py-2"
                  onClick={() => window.location.href = '/pricing'}
                  style={{
                    color: '#0d6efd',
                    borderColor: '#0d6efd',
                    backgroundColor: 'transparent',
                    transition: 'all 0.3s ease',
                    minWidth: '150px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(13, 110, 253, 0.05)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  View Pricing
                </button>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="col-md-6 text-center">
              <div className="front-image-wrap">
                <img
                  src={FrontImage}
                  alt="Bookkeeping Services"
                  className="front-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <ServiceCard />
      <WhatWeDoSection />
      <GoogleReviewSection />
      <Section4 />
      <LogoSection />
      
      {/* Contact Form Modal */}
      {showContactForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <ContactForm onClose={handleCloseContactForm} />
          </div>
        </div>
      )}
    </main>
  );
};
export default Home;